module.exports = __webpack_public_path__ + "img/LPN_Sword_Cyber_Plasma.f77ef3d1.png";